import React from 'react';

const Footer = ({ hideFooter = false }) => {
  if (hideFooter) return null;

  return (
    <div className="bg-transparent py-4">
      <div className="max-w-md mx-auto px-4 text-center">
        <div className="flex items-center justify-center space-x-4 mb-2">
          <a
            href="https://www.instagram.com/myskin.ai/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-pink-500 transition-colors duration-200"
            aria-label="Follow My Skin AI on Instagram"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path fillRule="evenodd" d="M12.017 0C8.396 0 7.999.01 6.756.048 5.517.086 4.668.222 3.935.42a5.902 5.902 0 0 0-2.134 1.384A5.902 5.902 0 0 0 .417 3.938C.219 4.671.083 5.52.045 6.759.007 8.002-.003 8.4-.003 12.021c0 3.622.01 4.02.048 5.263.038 1.238.174 2.087.372 2.82.204.783.532 1.447 1.384 2.135A5.902 5.902 0 0 0 3.935 23.58c.733.198 1.582.334 2.821.372 1.243.038 1.641.048 5.263.048 3.622 0 4.02-.01 5.263-.048 1.238-.038 2.087-.174 2.82-.372a5.902 5.902 0 0 0 2.134-1.384 5.902 5.902 0 0 0 1.383-2.134c.198-.733.334-1.582.372-2.82.038-1.244.048-1.642.048-5.264 0-3.622-.01-4.02-.048-5.263-.038-1.238-.174-2.087-.372-2.82a5.902 5.902 0 0 0-1.384-2.134A5.902 5.902 0 0 0 20.864.42C20.131.222 19.282.086 18.043.048 16.8.01 16.402 0 12.781 0h-.764zm-.025 5.838a6.183 6.183 0 1 1 0 12.365 6.183 6.183 0 0 1 0-12.365zm0 1.62a4.563 4.563 0 1 0 0 9.125 4.563 4.563 0 0 0 0-9.125zm8.966-3.97a1.446 1.446 0 1 1-2.891 0 1.446 1.446 0 0 1 2.891 0z" clipRule="evenodd" />
            </svg>
          </a>
        </div>
        <div className="text-xs text-gray-400">
          2026 © my-skin.ai
        </div>
        <div className="text-xs text-gray-400 mt-1">
          Powered by Rayora Enterprise
        </div>
      </div>
    </div>
  );
};

export default Footer;
